import { Component, DestroyRef, OnInit, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass, NgStyle, AsyncPipe } from '@angular/common';
import { ModalService } from '../modal/modal.service';
import { ArticlesService } from '../../services/articles.service';
import { EditingService } from '../../services/editing.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AddGalleryComponent } from '../forms/add-gallery/add-gallery.component';
import { ConfirmComponent } from '../modal/confirm/confirm.component';
import { StorageImage } from '../storage-images.util';

@Component({
  selector: 'app-gallery-article',
  templateUrl: './gallery-article.component.html',
  styleUrls: ['./gallery-article.component.scss'],
  imports: [NgClass, NgStyle, AsyncPipe]
})
export class GalleryArticleComponent implements OnInit {
  private modal = inject(ModalService);
  private articleService = inject(ArticlesService);
  private editService = inject(EditingService);
  private storage = inject(AngularFireStorage);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  readonly article = input.required<any>();
  readonly deleted = output<string>();

  images: StorageImage[] = [];
  openImage = signal('');

  ngOnInit() {
    this.loadImages();
  }

  private loadImages() {
    const selectedPaths: string[] = this.article().attributes.images ?? [];
    this.images = selectedPaths.map(path => ({
      path,
      imageDownloadPath: this.storage.ref(path).getDownloadURL()
    }));
  }

  toggleFullScreen(imagePath: string) {
    this.openImage.set(this.openImage() === imagePath ? '' : imagePath);
  }

  editArticle() {
    this.modal.open(AddGalleryComponent, {data: {title: 'Edit Article', content: this.article(), type: this.article().type}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.articleService.saveArticles(response);
      });
  }

  deleteArticle() {
    this.modal.open(ConfirmComponent, {data: {message: 'Delete this item?'}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(confirmed => {
        if (!confirmed) {
          return;
        }
        this.articleService.deleteArticle({type: this.article().type, id: this.article().id})
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.deleted.emit(this.article().id));
      });
  }
}
